$(function() {

  // ローディングアニメーション
  function loadingAnimation() {
    var sliderImg = "https://journal.komons-japan.com/wp-content/themes/komons-theme/img/main_slide01.jpg";

    var imgPreloader = new Image();
    var img = $('.first_view');
    var originSrc = img.attr('src');
    img.attr('src', "");
    console.log(originSrc);

    img.on({
      'load': function() {
        setTimeout(function() {
          $('.load_inner').addClass('delete');
          $('body').addClass('loaded');

          setTimeout(function() {
            $('.slide_fil').addClass('loaded');

            setTimeout(function() {
              $('.main_img').addClass('loaded');
              $('.main_logo').addClass('loaded');
              backGroundSlider($('#sliderBtn'));
            }, 100);
          }, 1200);

        }, 1700);

      }
    })

    img.attr('src', originSrc);

  }

  if (document.getElementById('index')) {
    loadingAnimation();
  }

  //カート画面の開閉
  function cartToggle(target){
    var cartLinkPc = $('#pcCart');
    var cartLinkFooter = $('#footerCart');
    var cartLinkSp = $('#spCart');
    var openState = 0;

    function cartOpen(){
      console.log('click!')
      if (openState == 0) {
        $('#slidecarthq .slidecarthq-overlay').addClass('open');
        $('#slidecarthq .slidecarthq').addClass('open');
        openState = 1;
        closeSet();
      } else {
        $('#slidecarthq .slidecarthq-overlay').removeClass('open');
        $('#slidecarthq .slidecarthq').removeClass('open');
        openState = 0;
      }
    }

    function closeSet(){
      console.log('closeSet!')
      $('#slidecarthq').find('.header').find('button').on({
        'click': function() {
          cartOpen();
        }
      });
      $('#slidecarthq').find('.slidecarthq-overlay').on({
        'click': function() {
          cartOpen();
        }
      });
    }

    function init(){
      cartLinkPc.on({
        'click': function() {
          cartOpen();
        }
      });
      cartLinkFooter.on({
        'click': function() {
          cartOpen();
        }
      });
      cartLinkSp.on({
        'click': function() {
          cartOpen();
        }
      });
    };

    init();
  }

  cartToggle($('#slidecarthq'));


  //ヘッダーのスクロール制御
function scrollJudge(target) {
  var scrollSwitch = 0;

  function afterScroll() {
    $('header').addClass('rolled');
    scrollSwitch = 1;
  };


  function beforeScroll() {
    $('header').removeClass('rolled');
    scrollSwitch = 0;
  };

  function init() {
    var timer = false;
    $(window).on({
      'load': function() {
        var scroll = $(window).scrollTop();
        if (scroll > 10) {
          if (scrollSwitch == 0) {
            afterScroll();
          }
        } else {
          if (scrollSwitch == 1) {
            beforeScroll();
          }
        }
      },
      'scroll': function() {
        if (timer !== false) {
          clearTimeout(timer);
        }
        timer = setTimeout(function() {
          var scroll = $(window).scrollTop();
          if (scroll > 60) {
            if (scrollSwitch == 0) {
              afterScroll();
            }
          } else {
            if (scrollSwitch == 1) {
              beforeScroll();
            }
          }
        }, 10);
      }
    });
  };

  init();

};
  scrollJudge($('body'));

  //ハンバーガーメニューの開閉
  function humMenuToggle(target) {
    var humButton = target.find('button');
    var closeBtn = $('.comp-close-menu button');
    var menuState = 0;
    var current_scrollY;

    function humMenuShift() {
      if (menuState == 0) {
        $('#spHummenu').addClass('open');
        $('#hummenu').removeClass('close').addClass('open');
        menuState = 1;
      } else {
        $('#spHummenu').removeClass('open');
        $('.hum_open').removeClass('hum_open');
        $('#hummenu').removeClass('open').addClass('close');
        menuState = 0;
      }
    }

    function init() {
      humButton.on({
        'click': function() {
          console.log('hummenu');
          humMenuShift();
        }
      });
      closeBtn.on({
        'click': function() {
          humMenuShift();
        }
      });
    }

    init()

  };

  humMenuToggle($('#hummenu'));

  //ハンバーガーメニューの2階層目以降の制御
  function spHummenu(target){
    var humMenuState = 0;
    var submenuPro = [];
    var backmenuPro = [];

    function backMenuSlide(f){
      var backTarget = '#' + f;
      $(backTarget).removeClass('hum_open');
    };

    function subMenuSlide(e){
      var menuTarget = '#' + e;
      console.log(menuTarget);
      $(menuTarget).addClass('hum_open');
    };

    function init(){
      $.each($('.hummenu_list01').find('.submenu'),function(index){
        submenuPro[index] = $(this).attr('pro');
        $(this).on({
          'click': function(){
            subMenuSlide(submenuPro[index]);
          }
        });
      });

      $.each($('.hummenu02').find('.submenu_back'),function(index){
        backmenuPro[index] = $(this).attr('pro');
        $(this).on({
          'click': function(){
            backMenuSlide(backmenuPro[index]);
          }
        });
      });

    };

    init();

  };

  spHummenu($('#spHummenu'));

  //商品一覧 FAQセクションの配置変更

  function insertFaqSection(target){
    console.log('insertFaqSection');
    var targetObj = $('#faqSection');
    var targetText = targetObj.html();

    function init(){
      target.append(targetText);
      targetObj.remove();
    }

    init();
  }


  if (document.getElementById('itemCategory')) {
    insertFaqSection($('#fawSection'));
  }

  function setItemListLayout(){
    function init(){
      if (document.getElementById('sectionFeature')) {
        $('.section-products').removeClass('plain');
      }
    }
    init()
  }

  if (document.getElementById('itemCategory')) {
    setItemListLayout($('article'));
  }

  //トップページ 動画再生
  function playMovieButtonIndex(target){
    var movieBox = [];
    var playButton = [];
    var movieThumb = [];
    var movieContent = [];
    var targetMovie = [];

    function moviePlay(e){
      var action = 'playVideo';
      movieBox[e].addClass('playing');
      movieContent[e].addClass('iframe');
      movieContent[e][0].contentWindow.postMessage('{"event":"command","func":"'+action+'","args":""}', '*');
    };

    function init(){
      $.each(target.find('.movie_box'),function(index){
        movieBox[index] = $(this);
        movieThumb[index] = $(this).find('.filter');
        movieContent[index] = $(this).find('iframe');
        targetMovie[index] = movieContent[index][0].contentWindow;
        movieThumb[index].on({
          'click': function(){
            moviePlay(index);
          }
        });
      });
    }

    init();
  }


  if (document.getElementById('index')) {
    playMovieButtonIndex($('#movieSlider'));
  }

  // 商品一覧 動画再生処理
  function playMovieButton(target){
    var playButton = [];
    var movieThumb = [];
    var movieContent = [];
    var targetMovie = [];

    function moviePlay(e){
      var action = 'playVideo';
      movieThumb[e].addClass('playing');
      movieContent[e].addClass('iframe');
      movieContent[e][0].contentWindow.postMessage('{"event":"command","func":"'+action+'","args":""}', '*');
    };

    function init(){
      $.each(target.find('.movie_poster'),function(index){
        movieThumb[index] = $(this).parent('.img_wrap');
        movieContent[index] = movieThumb[index].find('iframe');
        targetMovie[index] = movieContent[index][0].contentWindow;
        $(this).on({
          'click': function(){
            moviePlay(index);
          }
        });
      });
    }

    init();
  }


  if (document.getElementById('itemCategory')) {
    playMovieButton($('.section-feature'));
  }



  //商品詳細: 回転画像にalt入れて説明文にする
  function inputThumbAltText(target){
    var altText = target.text();
    var textArray = altText.split(",");
    var thumbList = $('#thumbList');
    var itemName = $('h1').text();
    var splitItemName = $('h1').text().split(' ');
    var itemColor = splitItemName[splitItemName.length - 1];
    var descTitle = $('#descTitle');

    function init(){
      $.each(thumbList.find('img'), function(index) {
        if(textArray[index] != undefined && textArray[index].length > 0){
          $(this).attr("alt",textArray[index]);
          /*if(index == 0){
            $(this).attr("alt", 'カラー：' + itemColor);
          }else{
            $(this).attr("alt",textArray[index]);
          }*/
        }
      });

      var titleLength = descTitle.text().length;
      var descContent = $("meta[name=Keywords]").attr("content");
      console.log('descContent:' + descContent);
      if(titleLength == 0){
        descTitle.html(descContent);
      }

      target.remove();
    }

    init();
  }

  if (document.getElementById('itemDetail')) {
    inputThumbAltText($('#thumnailAlt'));
  }

  //商品詳細: 商品サムネイル切り替え
  function itemDetailThumbnail(target) {
    var thumbBox = $('#thumbBox');
    var caption = $('#caption');
    var imgthumb = $('#imgthumb');
    var currentThumb = $('#currentThumb');
    var allThumb = $('#allThumb');
    var slideNextButton = $('#slideNext');
    var slidePrevButton = $('#slidePrev');
    var thumbButton = [];
    var currentSlide = 0;
    var imgObj = [];
    var imgAlt = [];
    var time = 300;
    var thumbLength = target.children("span").length;

    function thumbChange(num){
      thumbBox.stop().animate({ opacity: 0 }, time, function() {
          thumbBox.attr('src', imgObj[num]);
          $('.active_thumb').removeClass('active_thumb');
          thumbButton[num].addClass('active_thumb');
          caption.text(imgAlt[num][1]);
          currentThumb.text(num + 1);
          currentSlide = num;
          thumbBox.stop().animate({ opacity: 1 }, time);
      });
    }

    function slideChange() {
      targetSlide = target.find('.slide' + currentSlide);
      target.find('.active_slide').removeClass('active_slide');
      targetSlide.addClass('active_slide');
      target.find('.current').text(currentSlide);
    };

    function slideNext(){
      if (currentSlide < thumbLength - 1) {
        currentSlide = currentSlide + 1;
      } else {
        currentSlide = 0;
      }
      thumbChange(currentSlide);
    };

    function slidePrev(){
      if (currentSlide == 0) {
        currentSlide = thumbLength - 1;
      } else {
        currentSlide = currentSlide - 1;
      }
      thumbChange(currentSlide);
    };

    function tabTouch(){
      if(startTouchX - endTouchX > 50){
        slideNext();
      }else if(startTouchX - endTouchX < - 50){
        slidePrev();
      }
    };

    function windowDrag() {
      if (startDragX - endDragX > 100) {
        slideNext();
      } else if (startDragX - endDragX < -100) {
        slidePrev();
      }
    };

    function init(){
      allThumb.text(thumbLength);
      $.each(target.find('span'), function(index) {
        thumbButton[index] = $(this);
        imgObj[index] = $(this).children('img').attr("src");
        imgAlt[index] = $(this).children('img').attr("alt").split(',');

        thumbButton[index].on({
          'click': function() {
            thumbChange(index);
          }
        });

      });

      if(thumbLength != 0){
        caption.text(imgAlt[0][1]);
        thumbButton[0].addClass('active_thumb');
      }

      slideNextButton.on({
        'click': function() {
          slideNext();
        }
      });

      slidePrevButton.on({
        'click': function() {
          slidePrev();
        }
      });

      imgthumb.on({
        'dragstart': function(e) {
          startDragX = event.pageX;
        },
        'dragend': function(e) {
          endDragX = event.pageX;
          windowDrag();
        }
      });

      imgthumb.on({
        'touchstart' : function(e){
          startTouchX = event.changedTouches[0].pageX;
        },
        'touchend' : function(e){
          endTouchX = event.changedTouches[0].pageX;
          tabTouch();
        }
      });

    }

    init();
  }
  if (document.getElementById('itemDetail')) {
    itemDetailThumbnail($('#thumbList'));
  }

  function relatedItemSet(target){
    function init(){
      var targetHeight = $('#relatedItemHeight').offset().top - 60;
      target.css({'top': targetHeight + 'px'});
      target.addClass('display');
    }

    init();
  }

  if (document.getElementById('itemDetail')) {
    relatedItemSet($('#detailLeft'));
  }




  //バリエーション選択欄をラジオボタン化
  function radioVariationSelect(target){
    console.log('radioVariationSelect');
    var inputValue = [];
    var inputPrice = [];
    var inputName = [];
    var wrapper = [];
    var button = [];
    var selectBox = $('#hiddenSelect');
    var priceDisplay = $('#priceDisplay');
    var priceDisplayDiscout = $('#priceDisplayDiscout');
    var discountPrice = $('#discountPrice');
    var discountRate = discountPrice.attr('rate');
    var variationController = $('#variationController');
    var controller = [];
    var controllerValue = [];
    var numStock = 0;
    var url = location.href;

    function selectChange(e){
      if (document.getElementById('priceDisplay')) {
        if(url.includes('/en', 0)){
          selectBox.val(inputValue[e]);
          priceDisplay.html(inputPrice[e]/*+"(including tax)" 2026-09 海外向けは税表記なし*/);
        }else{
          selectBox.val(inputValue[e]);
          priceDisplay.html(inputPrice[e] + '(税込)')
        }
      }else if (document.getElementById('priceDisplayDiscout')){
        if(url.includes('/en', 0)){
          selectBox.val(inputValue[e]);
          priceDisplayDiscout.html('<span class="strike">'+inputPrice[e]/*+"(including tax)"*/+"</span>");
          var priceNum = inputPrice[e].replace(/,/g, '').replace(/¥/g, '');
          console.log('priceNum:' + priceNum);
          var discountPriceNum = Number(priceNum) - Number(priceNum) * discountRate / 100;
          discountPrice.html("\xA5"+discountPriceNum.toLocaleString()/*+"(including tax)"*/)
        }else{
          selectBox.val(inputValue[e]);
          priceDisplayDiscout.html('<span class="strike">' + inputPrice[e] + '(税込)' + '</span>');
          var priceNum = inputPrice[e].replace(/,/g, '').replace(/¥/g, '');
          console.log('priceNum:' + priceNum);
          var discountPriceNum = Number(priceNum) - Number(priceNum) * discountRate / 100;
          discountPrice.html('¥' + discountPriceNum.toLocaleString() + '(税込)')
        }
      }
    };

    function init(){
      $.each(target.find('.variation_item'), function(index) {
        wrapper[index] = $(this);
        button[index] = $(this).find('input[type="radio"]');
        inputName[index] = $(this).find('.name').text();
        inputPrice[index] = button[index].attr('prop');
        inputValue[index] = button[index].attr('value');
        wrapper[index].on({
          'click': function() {
            selectChange(index);
          }
        });
      });
      button[0].click();
      if (document.getElementById('variationController')) {
        console.log('variationController');
        $.each(variationController.find('.controller_item'), function(index) {
          controller[index] = $(this);
          controllerValue[index] = $(this).find('.title').html();
          controller[index].on({
            'click': function() {
              $.each(target.find('.variation_item'), function(i) {
                if(inputName[i].indexOf(controllerValue[index]) > -1){
                  numStock = numStock + 1; wrapper[i].css({'display': 'block'});
                  if(numStock == 1){
                    wrapper[i].find('label').click();
                  }
                }else{
                  wrapper[i].css({'display': 'none'});
                }
              });
              numStock = 0;
            }
          });
        });
        controller[0].find('label').click();
      }
    }

    init();

  }

  if (document.getElementById('itemDetail')) {
    radioVariationSelect($('#variationInput'));
  }

  //会社概要 タブ切り替えレイアウト
  function chartTab(target){
    var tabState = 0;
    var switchButton = [];
    function chartSwitch(e){
      if(tabState != e){
        $('.selected_selector').removeClass('selected_selector');
        switchButton[e].addClass('selected_selector');
        var targetContent = switchButton[e].attr('prop');
        console.log(targetContent);
        $('.display_chart').removeClass('display_chart');
        $(targetContent).addClass('display_chart');
        tabState = e;
      }

    }

    function init(){
      $.each(target.find('.button'), function(index) {
        switchButton[index] = $(this);
        switchButton[index].on({
          'click': function(){
            chartSwitch(index);
          }
        });
      });
    }

    init();

  }

  if (document.getElementById('itemDetail')) {
    chartTab($('#chartSelector'));
  }

  //商品カテゴリ開閉式レイアウト
  function variationToggle(target){
    var toggleState = [];
    var wrapper = [];
    var button = [];
    var toggle = [];

    function toggleMove(e){
      var buttonHeight = button[e].outerHeight();
      var toggleHeight = toggle[e].outerHeight();
      if(toggleState[e] == 0){
        var contentHeight = buttonHeight + toggleHeight;
        button[e].addClass('open');
        toggleState[e] = 1;
      }else{
        var contentHeight = buttonHeight;
        button[e].removeClass('open');
        toggleState[e] = 0;
      }
      wrapper[e].css({height: contentHeight + 'px'});
    }

    function init(){
      $.each(target.find('.toggle_item'), function(index) {
        toggleState[index] = 0;
        wrapper[index] = $(this);
        button[index] = wrapper[index].children('button');
        var buttonHeight = button[index].outerHeight();
        toggle[index] = wrapper[index].children('.toggle_contents');
        wrapper[index].css({height: buttonHeight + 'px'});
        button[index].on({
          'click': function() {
            toggleMove(index);
          }
        });
      });
    }

    init();
  }

  if (document.getElementById('itemCategory')) {
    variationToggle($('article'));
  }

  //商品カテゴリ開閉式レイアウト(ファラオ)
  function variationToggle02(target){
    var toggleState = [];
    var wrapper = [];
    var button = [];
    var toggle = [];

    function toggleMove(e){
      var buttonHeight = button[e].outerHeight();
      var toggleHeight = toggle[e].outerHeight();
      if(toggleState[e] == 0){
        var contentHeight = buttonHeight + toggleHeight;
        button[e].addClass('open');
        toggleState[e] = 1;
      }else{
        var contentHeight = buttonHeight;
        button[e].removeClass('open');
        toggleState[e] = 0;
      }
      wrapper[e].css({height: contentHeight + 'px'});
    }

    function init(){
      $.each(target.find('.comp-toggle-pharaoh'), function(index) {
        toggleState[index] = 0;
        wrapper[index] = $(this);
        button[index] = wrapper[index].children('button');
        var buttonHeight = button[index].outerHeight();
        toggle[index] = wrapper[index].children('.toggle_contents');
        wrapper[index].css({height: buttonHeight + 'px'});
        button[index].on({
          'click': function() {
            toggleMove(index);
          }
        });
      });
    }

    init();
  }

  if (document.getElementById('itemCategory')) {
    variationToggle02($('article'));
  }

  //よくある質問(FAQ用のトグル)
  function faqToggle(target) {
    var toggleItem = [];
    var toggleButton = [];
    var toggleContents = [];
    var toggleState = [];

    function toggleMove(e) {
      var w = $(window).width();
      var toggleHeight = toggleButton[e].outerHeight();
      var targetHeight = toggleContents[e].outerHeight();
      if (toggleState[e] == -1 || toggleState[e] == 0) {
        toggleButton[e].addClass('active');
        if (w > 750) {
          toggleItem[e].css({
            'height': toggleHeight + targetHeight + 40 + 'px'
          });
        } else {
          toggleItem[e].css({
            'height': toggleHeight + targetHeight + 30 + 'px'
          });
        }
        toggleState[e] = 1;
      } else {
        toggleButton[e].removeClass('active');
          toggleItem[e].css({
            'height': toggleHeight + 4 + 'px'
          });
        toggleState[e] = 0;
      }
    }

    function init() {
      $.each(target.find('.qa_item'), function(index) {
        toggleItem[index] = $(this);
        toggleButton[index] = $(this).find('.qa_button');
        toggleContents[index] = $(this).find('.qa_contents');
        $(this).css({'height': toggleButton[index].outerHeight() + 4 + 'px'});
        toggleState[index] = -1;
        toggleButton[index].on({
          'click': function() {
            toggleMove(index);
          }
        });
      });
    }

    init();

  }

  if (document.getElementById('faq')) {
    faqToggle($('article'));
  }
  if (document.getElementById('faqWrap')) {
    faqToggle($('article'));
  }

  //会社概要 タブ切り替えレイアウト
  function contentsTab(){
    var tabState = 0;
    var switchButton = [];
    function tabSwitch(e){
      if(tabState != e){
        $('.checked').removeClass('checked');
        switchButton[e].addClass('checked');
        var targetContent = switchButton[e].attr('jump');
        console.log(targetContent);
        $('.selected-tab').removeClass('selected-tab');
        $(targetContent).addClass('selected-tab');
        tabState = e;
      }

    }

    function init(){
      $.each($('button'),function(index){
        switchButton[index] = $(this);
        switchButton[index].on({
          'click': function(){
            tabSwitch(index);
          }
        });
      });
    }

    init();

  }

  if (document.getElementById('about')) {
    contentsTab($('#tabArea'));
  }


  //同一ページにて、ページ内スクロールを有効にする
  function faqScroll(target) {
    var url = location.href;
    var pageUrl = url.split("#");
    console.log(pageUrl[0]);
    var scrollObj = [];

    function windowMove(e) {
      var w = $(window).width();
      console.log(scrollObj[e]);
      var scrollHeight = $(scrollObj[e]).offset().top;
      if (w > 1100) {
        var adScroll = scrollHeight;
      } else {
        var adScroll = scrollHeight;
      }
      $("html, body").animate({
        scrollTop: adScroll
      }, 500);
      return false;
    }

    function init() {
      $.each(target.find('a'), function(index) {
        console.log('guideNav!!!');
        var hrefLink = $(this).attr('href');
        var seikiLink = hrefLink.split("#");
        $(this).attr('href', 'javascript:void(0);');
        scrollObj[index] = $(this).attr("jump");
        $(this).on({
          'click': function() {
            windowMove(index);
            if( $(this).attr('option') == 'close'){
              $('#hummenu').find('.close_button').click();
            }
          }
        });
      });
    }

    init();

  }

  if (document.getElementById('guide')) {
    faqScroll($('#guideNav'));
    faqScroll($('#guideNav2'));
  }

  //ログイン⇄パスワードリセットの画面切り替え
  function changeLoginFunction(target){
    var RecoverPassword = $('#RecoverPassword');
    var loginBack = $('#loginBack');
    var Wrapper = $('.section-login');

    function init(){
      RecoverPassword.on({
        'click': function(){
          Wrapper.removeClass('loginSet').addClass('resetSet');
        }
      });
      loginBack.on({
        'click': function(){
          Wrapper.removeClass('resetSet').addClass('loginSet');
        }
      });
    };

    init();
  }
  if (document.getElementById('login')) {
    changeLoginFunction($('article'));
  }

  //アドレス登録画面の切り替え制御
  function addressEditSwitch(target){
    var mypageLeft = $('.mypage_left');
    var editAddress = $('#editAddress');
    var switchButton = $('#switchButton');
    var AdreesId = [];
    var AdreesProp = [];
    function windowScroll(){
      var w = $(window).width();
      var scrollHeight = $('.mypage_left').offset().top;
      if (w > 1100) {
        var adScroll = scrollHeight - 180;
      } else {
        var adScroll = scrollHeight - 80;
      }
      $("html, body").animate({
        scrollTop: adScroll
      }, 500);
    }
    function displayChange(num, id){
      mypageLeft.removeClass('addAddressMode').addClass('editAddressMode');
      $.each(editAddress.find('.edit_wrap'), function(index) {
        AdreesProp[index] = $(this).attr('prop');
        console.log('id:' + id + '/prop:' + AdreesProp[index]);
        if(id == AdreesProp[index] ){
          $(this).css({'display': 'block'});
        }else{
          $(this).css({'display': 'none'});
        }
        windowScroll();
      });
    }
    function displayBack(){
      mypageLeft.addClass('addAddressMode').removeClass('editAddressMode');
      $('.edit_wrap').css({'display': 'none'});
      windowScroll();
    }
    function init(){
      $.each(target.find('.address_edit'), function(index) {
        AdreesId[index] = $(this).attr('prop');
        $(this).on({
          'click': function() {
            displayChange(index, AdreesId[index]);
          }
        });
      });
      switchButton.on({
        'click': function() {
          displayBack();
        }
      })
    };

    init();
  }

  if (document.getElementById('address')) {
    addressEditSwitch($('#orderRight'));
  }

  function presetContactCategory(){
    var param = location.search;
    console.log('param:' + param);
    var targetOption = $('#ContactFormFlavor');

    function init(){
      if(param == '?option2'){
        targetOption.val('商品の取り扱いについて');
      }else if(param == '?option3'){
        targetOption.val('プログラム導入について');
      }
    }

    init();

  }



  if (document.getElementById('contact')) {
    presetContactCategory($('article'));
  }

  //ハルメソッドページ サービス一覧のフィルター
  function filterServiceList(target){
    var serviceList = $('#serviceList');
    var filterButton = [];
    var buttonClass = [];
    var buttonState = [];

    function buttonStateSet(e){
      if(buttonState[e] == 1){
        $.each(target.find('button'),function(index){
          $(this).removeClass('clear');
          buttonState[index] = 0;
          filterService(0)
        });
      }else if(buttonState[e] = 0 || e != 0){
        $.each(target.find('button'),function(index){
          $(this).addClass('clear');
          buttonState[index] = 0;
        });
        filterButton[e].removeClass('clear');
        buttonState[e] = 1;
        filterService(e)
      }else{
        $.each(target.find('button'),function(index){
          $(this).removeClass('clear');
          buttonState[index] = 0;
          filterService(0)
        });
      }
    }

    function filterService(e){
      $.each(serviceList.find('.list_item'),function(index){
        var listClass = $(this).attr('prop');
        if(buttonClass[e] == 'all'){
          $(this).css({'display': 'block'});
        }else if(buttonClass[e] == listClass){
          $(this).css({'display': 'block'});
        }else{
          $(this).css({'display': 'none'});
        }
      });
    }
    function init(){
      $.each(target.find('button'),function(index){
        console.log(index);
        filterButton[index] = $(this);
        buttonClass[index] = $(this).attr('class');
        buttonState[index] = 0;
        filterButton[index].on({
          'click': function(){
            buttonStateSet(index);
          }
        });
      });
    }

    init();
  }


  if (document.getElementById('method')) {
    filterServiceList($('#categoryFilterButtons'));
  }



  function setMyForm(target){

    var creditCartButton = $('.comp-submit-button');
    var ERROR_MESSAGE_CLASSNAME = 'errorMsg'; //エラー時のメッセージ要素のclass名
    var ERROR_INPUT_CLASSNAME = 'errorInput'; //エラー時のinput要素のclass名
    var submitText = $('#formMessage');

    var items = []; //チェック対象となるテキスト入力要素を格納した配列

    //項目チェックする
    var checkAll = function(){
      var errorCount = 0;

      //input,textareaのチェック
      for( var i=0; i<items.length; i++ ){
        if( items[i].prop('isSuccess') == false ){
          errorCount++;
        };
      };

      console.log(errorCount);

      //エラーカウントが0であれば、エラー無し
      var priceDisplay = $('#priceAmount2').text();
      console.log(priceDisplay);
      if( errorCount == 0 ){
        creditCartButton.removeClass('disabled');
        creditCartButton.addClass('able');
        submitText.html('送信する');
      }else{
        creditCartButton.removeClass('able');
        creditCartButton.addClass('disabled');
        submitText.html('未入力項目があります');
      };
    };

    //エラーメッセージの追加
    var addErrorMessage = function(selector, msg){
      removeErrorMessage(selector);
      selector.parent('div').append('<span class="attention '+ERROR_MESSAGE_CLASSNAME+'">'+msg+'</span>');
      selector.addClass(ERROR_INPUT_CLASSNAME);
    };

    //エラーメッセージの削除
    var removeErrorMessage = function(selector){
      var msgSelector = selector.parent().find('.'+ERROR_MESSAGE_CLASSNAME);
      if( msgSelector.length != 0 ){
        msgSelector.remove();
        selector.removeClass(ERROR_INPUT_CLASSNAME);
      };
    };

    //input,textareaの未入力チェック
    var checkEmptyText = function(selector, msg){
      if( selector.val() == '' ||  selector.val() == null){
        console.log('check!');
        if(msg != 0){
          addErrorMessage(selector, msg);
        }
        selector.prop('isSuccess', false);
      }else{
        if(msg != 0){
          removeErrorMessage(selector);
        }
        selector.prop('isSuccess', true);
      };
    };

    var emptyThrough = function(selector){
      if( selector.val() == '' ||  selector.val() == null){
        removeErrorMessage(selector);
        selector.prop('isSuccess', true);
      }
    };

    //radioの未入力チェック
    var checkRadioBox = function(selector, msg){
      if( selector.prop("checked")){
        removeErrorMessage(selector);
        selector.prop('isSuccess', true);
      }else{
        addErrorMessage(selector, msg);
        selector.prop('isSuccess', false);
      };
    };

    //文字列のフォーマットチェック
    function checkFormatText(selector, _mode, msg){
      var value = selector.val();
      switch(_mode){
        //全角のみ
        case 0:
          if(value.match(/^[^ -~｡-ﾟ]*$/)){
            selector.prop('isSuccess', true);
            removeErrorMessage(selector);
          }else{
            selector.prop('isSuccess', false);
          };
          break;
        //ふりがなのみ
        case 1:
          if(value.match(/^[\u3040-\u309F]+$/)){
            selector.prop('isSuccess', true);
          }else{
            selector.prop('isSuccess', false);
          };
          break;
        //半角数字のみ
        case 2:
          if(value.match(/^[0-9]*$/)){
            selector.prop('isSuccess', true);
          }else{
            selector.prop('isSuccess', false);
          };
          break;
        //メールアドレスかどうか
        case 3:
          if(value.match(/^[a-zA-Z0-9!$&*.=^`|~#%'+\/?_{}-]+@([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,6}$/)){
            selector.prop('isSuccess', true);
          }else{
            selector.prop('isSuccess', false);
          };
          break;
      };
      if( selector.prop('isSuccess') == false ){
        addErrorMessage(selector, msg);
      }else{
        removeErrorMessage(selector);
      };
    };

    //初期設定
    var init = function(){
      creditCartButton.addClass('disabled');

      //input要素を配列に格納
      items = [
        target.find('#ContactFormFlavor'), //0 カテゴリー
        target.find('#ContactForm-name'), //1 名前
        target.find('#ContactForm-email'), //2 メールアドレス
        target.find('#ContactForm-message'), //3 メッセージ
      ];
      //input要素のプロパティを設定
      $.each(items, function(index){
        items[index].prop('isSuccess', false);
      });
      //enterキーでsubmitしてしまうのを防止する
      target.find('input[type=text]').on({
        'keypress': function(e){
          if( (e.keyCode == 13) ) return false;
        }
      });
      //項目：名前のセレクタにblurイベントを設定
      items[0].on({
        'blur': function(){
          console.log('0');
          checkEmptyText( items[0], '※お問い合わせ項目を選択してください。' );
          checkAll();
        },
      });
      //項目：名前のセレクタにblurイベントを設定
      items[1].on({
        'blur': function(){
          console.log('1');
          checkEmptyText( items[1], '※お名前を入力してください。' );
          checkAll();
        }
      });
      //項目：電話番号のセレクタにblurイベントを設定
      items[2].on({
        'blur': function(){
          checkEmptyText( items[2], '※メールアドレスを入力してください。');
          if( items[2].prop('isSuccess') ) checkFormatText( items[2], 3, '※Please fill your mail address correctly.');
          checkAll();
        }
      });
      //項目：電話番号のセレクタにblurイベントを設定
      items[3].on({
        'keyup': function(){
          checkEmptyText( items[3], '※お問い合わせ内容を入力してください。');
          checkAll();
        }
      });
    };

    init();

  };
  if (document.getElementById('contact')) {
    setMyForm($('article'));
  }

  // 多言語対応
  //ハルメソッドページ サービス一覧のフィルター
  function forEnglishPage(){
    var url = location.href;
    var multiLang = [];
    var englishTxt = [];

    function init(){
      // 共通
      $('#homeLink').attr('href', '/en');
      $('#homeLink2').attr('href', '/en');
      $('#linkJa').attr('href', '/');
      $('#linkJa2').attr('href', '/');
      $('#linkJa').removeClass('disnone');
      $('#linkJa2').removeClass('disnone');
      $.each($('article').find('.only_en'),function(index){
        console.log(index);
        $(this).css({'display': 'block'});
      });
      $.each($('article').find('.only_ja'),function(index){
        console.log(index);
        $(this).css({'display': 'none'});
      });
      // カスタムフィールド手動翻訳対策(英語表示の際に"cart_wrap"が表示されない不具合があるのでコメントアウトしています)
/*
      if (document.getElementById('itemDetail')) {
        $('.cart_wrap').remove();
      }
*/
    }

    if(url.includes('/en', 0)){
      init();
    }else{
      $('#linkEn').removeClass('disnone');
      $('#linkEn2').removeClass('disnone');
      $.each($('article').find('.only_en'),function(index){
        console.log(index);
        $(this).css({'display': 'none'});
      });
      $.each($('article').find('.only_ja'),function(index){
        console.log(index);
        $(this).css({'display': 'block'});
      });
    }
  }

  forEnglishPage();




  if (document.getElementById('method')) {
    filterServiceList($('#categoryFilterButtons'));
  }

  if (document.getElementById('index')) {
     $('#indexSlider').slick({
       accessibility: false,
       infinite: true,
       dots: true,
       slidesToShow: 1,
       centerMode: false,
       autoplay: true,
       autoplaySpeed: 3000,
       speed: 1000,
       responsive: [
         {
           breakpoint: 1100,
           settings: {
             slidesToShow: 1,
             centerPadding: '0',
             centerMode: true,
           }
         },
         {
           breakpoint: 750,
           settings: {
             slidesToShow: 1,
             centerPadding: '0',
             centerMode: true,
           }
         }
       ]
     });
  }

  if (document.getElementById('index')) {
     $('#movieSlider').slick({
       accessibility: false,
       infinite: false,
       dots: true,
       slidesToShow: 3,
       centerMode: true,
       autoplay: false,
       responsive: [
         {
           breakpoint: 1100,
           settings: {
             slidesToShow: 1,
             infinite: true,
             centerPadding: '15%',
             centerMode: true,
           }
         },
         {
           breakpoint: 750,
           settings: {
             infinite: true,
             slidesToShow: 1,
             centerPadding: '7%',
             centerMode: true,
           }
         }
       ]
     });
  }

  if (document.getElementById('method')) {
     $('#methodSlider').slick({
       accessibility: false,
       infinite: false,
       dots: true,
       slidesToShow: 3,
       centerMode: true,
       autoplay: false,
       responsive: [
         {
           breakpoint: 1100,
           settings: {
             slidesToShow: 1,
             infinite: false,
             centerPadding: '15%',
             centerMode: false,
           }
         },
         {
           breakpoint: 750,
           settings: {
             slidesToShow: 1,
             centerPadding: '7%',
           }
         }
       ]
     });
  }

});
